// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"79":"component---src-templates-index-tsx","218":"component---src-pages-404-tsx","351":"commons","446":"b4ffff85"}[chunkId] + "-" + {"79":"00a9b7b6279356f76211","218":"fc3520104734a0570975","351":"8d6bcb83c1ab7d4deb1f","446":"a50830ce596f58570c33"}[chunkId] + ".js";
};